import { ChangeEvent } from "react";
import { useI18n } from "i18n";
import { Checkbox } from "@remo-co/ui-core/src/components/Checkbox";
import { FormControlLabel } from "@remo-co/ui-core/src/components/FormControlLabel";
import { styles } from "./styles";

export interface IDoNotShowAgainProps {
  doNotShowAgain: boolean;
  onValueChange: (checked: boolean) => void;
}

export const DoNotShowAgain = ({
  doNotShowAgain,
  onValueChange,
}: IDoNotShowAgainProps) => {
  const onCheck = (ev: ChangeEvent<HTMLInputElement>) => {
    onValueChange(ev.target.checked);
  };
  const { t } = useI18n();

  return (
    <FormControlLabel
      sx={styles.root}
      control={
        <Checkbox
          color="primary"
          checked={doNotShowAgain}
          onChange={onCheck}
          value="doNotShowAgain"
        />
      }
      label={t("label.not.notify.show")}
    />
  );
};
